export const enum SoccerResultId {
  FirstHalf = 4,
  SecondHalf = 5,
  ExtratimeFirstHalf = 133,
  ExtratimeSecondHalf = 134,
  Penalty = 7,
}
